import Vue                from 'vue'
import App                from './App.vue'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import VueRouter          from 'vue-router'
import Home               from './components/homepage/MainHome'
import MainPrograms       from './components/programs/MainPrograms'
import MainHotels         from './components/hotels/MainHotels'
import Err404             from './components/global/Err404'
import MainSearchResaults from './components/search/MainSearchResaults'
import MainRestaurants    from './components/restaurants/MainRestaurants'
import MainShopping       from './components/shopping/MainShopping'
import MainTransportation from './components/transportation/MainTransportation'
import MainPlaces         from './components/places/MainPlaces'
import MainPartners       from './components/partners/MainPartners'
import MainBlog           from './components/blog/MainBlog'
import SingleBlogPage     from './components/blog/SingleBlogPage'
import SingleProgPage     from './components/programs/SingleProgPage'
import SinglePlacePage    from './components/places/SinglePlacePage'
import PlaceSearch        from './components/places/PlaceSearch'
Vue.use(VueRouter)


const router = new VueRouter({
    // mode:'history',
    routes:[
      //ar
      {name:'Error404', component:Err404, path:'*' },
      {name:'home', component: Home, path:'/'},
      {name:'programs', component:MainPrograms,path:'/ar/البرامج'},
      {name:'hotels', component:MainHotels,path:'/ar/الفنادق'},
      {name:'restaurants', component:MainRestaurants,path:'/ar/المطاعم'},
      {name:'shopping', component:MainShopping,path:'/ar/التسوق'},
      {name:'transportation', component:MainTransportation,path:'/ar/النقل'},
      {name:'transportation', component:MainPlaces,path:'/ar/المزارات'},
      {name:'partners', component:MainPartners,path:'/ar/شركاؤنا'},
      {name:'blog', component:MainBlog,path:'/ar/المواضيع'},

      //single pages
      {name:'posts', component:SingleBlogPage,path:'/ar/المواضيع/*'},
      {name:'singleProg',component:SingleProgPage,path:'/ar/البرامج/*'},
      {name:'place', component:SinglePlacePage,path:'/ar/المزارات/*'},
      //en
      {name:'Error404', component:Err404, path:'*' },
      {name:'home', component: Home, path:'/'},
      {name:'programs', component:MainPrograms,path:'/en/programs'},
      {name:'hotels', component:MainHotels,path:'/en/hotels'},
      {name:'search', component:MainSearchResaults,path:'/en/search'},
      {name:'restaurants', component:MainRestaurants,path:'/en/restaurants'},
      {name:'shopping', component:MainShopping,path:'/en/shopping'},
      {name:'transportation', component:MainTransportation,path:'/en/transportation'},
      {name:'places', component:MainPlaces,path:'/en/places'},
      {name:'partners', component:MainPartners,path:'/en/partners'},
      {name:'blog', component:MainBlog,path:'/en/blog'},

      //single pages
      {name:'posts', component:SingleBlogPage,path:'/en/blog/*'},
      {name:'singleProg',component:SingleProgPage,path:'/en/programs/*'},
      {name:'place', component:PlaceSearch,path:'/en/places/place/*'},
      {name:'place', component:SinglePlacePage,path:'/en/places/*'},
    ]
});


Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
